module.exports = __webpack_public_path__ + "img/share_icon.3deb0da3.png";